import React from "react";

import "./skills.css";
const Skills = () => {
  return (
    <div className=" container skills">
      <div className="header">Skills</div>
      <p>I am a full stack web developer.</p>
      <p>
        I use techs like
        <b> MongoDB</b>,<b> Express</b>,<b> Node.js</b>,<b> React</b>,{" "}
        <b> Redux </b>
        and other libraries and framework related to them.{" "}
      </p>
      <hr />
      <div className="header">Back-end web development</div>
      <p>
        I work with <b> Node.js </b> in backend along with other libraries
        related to it.
      </p>
      <p>My skills in back-end include:</p>
      <ul>
        <li>Ablility to create Restful APIs and microservices. </li>
        <li>
          Ability to use database like <b> MongoDB </b> with <b> Mongoose</b>.
        </li>
        <li>
          Ability to work with <b>Express</b>.
        </li>
      </ul>
      <hr />
      <div className="header">Front-end web development</div>
      <p>
        I work with <b> React </b> in front-end.{" "}
      </p>
      <p>My skills in front-end include:</p>

      <ul>
        <li>
          Ability in working with latest version of React with features like{" "}
          <b> hooks </b>, <b>react-router </b>, etc.
        </li>
        <li>
          Ability to work in state management with <b>context API</b> and
          <b> Redux</b>.
        </li>
        <li>Ability to create responsive web design.</li>
      </ul>
    </div>
  );
};

export default Skills;
